import { Button as RadixButton } from "@radix-ui/themes";
import styled from "@emotion/styled";

export const Button = styled(RadixButton)`
  border: 1px solid rgb(0, 0, 0);
  background-color: rgb(255, 255, 255);
  box-shadow: rgb(187, 187, 187) 2px 2px 0px 0px;
  padding: 1.4px 7px 0px 7px;
  font-size: 14px;
  line-height: 21px;
  color: rgb(0, 0, 0);
  cursor: pointer;
  outline: none !important;
  border-radius: 0;
  user-select: none;
  text-align: center;
  font-family:
    -apple-system, system-ui, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;

  &:hover {
    background-color: rgb(245, 245, 245);
  }

  &:active {
    box-shadow: rgb(187, 187, 187) 2px 2px 0px 0px inset;
    background-color: rgb(250, 250, 250);
  }
`;
